import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import StatusChip from "./statusChip.component";
import { capitalizeFirst } from "../../../../utils/digitalTwinUtils";
import Searchbar from "../mainGridComponents/searchBar.components";

/**
 * Component used in the Digital Twin platform side menu.
 * @param area - name of the area containing the plants
 * @param plants - plants located within the area or field
 * @param onClick - function triggered when a plant is clicked
 * @returns a card displaying the area and listing its plants, with a search feature
 */
export default function CustomSmallSideMenuCard({
  area = "Area nord",
  crops = [],
  plants = [],
  onClick,
}) {
  const [search, setSearch] = React.useState("");

  function getRandomStatus() {
    const statuses = ["ok", "fine", "bad"];
    return statuses[Math.floor(Math.random() * statuses.length)];
  }

  const getPlantName = (plant) =>
    `${capitalizeFirst(plant?.plant_type) || "Pianta"} ${plant?.plant_number ?? ""}`.trim();

  const filteredPlants = plants.filter((plant) =>
    getPlantName(plant).toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Card variant="elevation" sx={{ height: "70vh" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          p: 0,
        }}
      >
        <Searchbar value={search} onChange={setSearch} />
        <Box p={1} sx={{ overflowY: "auto", flex: 1 }}>
          {filteredPlants.map((crop, idx) => (
            <Box
              key={idx}
              flexDirection="row"
              flex={1}
              display={"flex"}
              alignContent="center"
              alignItems="center"
              justifyContent="space-between"
              m={1}
              p={1}
              borderBottom={"1px solid #e0e0e0bf"}
              sx={{ cursor: "pointer" }}
              onClick={() => onClick && onClick(crop)}
            >
              <Typography variant="body2" sx={{ mb: 1 }}>
                {getPlantName(crop)}
              </Typography>
              <StatusChip status={getRandomStatus()} />
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
  /*   return (
    <Card variant="outlined">
      <CardContent>
        <Box
          flexDirection="row"
          flex={1}
          m={1}
          p={1}
          display={"flex"}
          alignContent="center"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6">
            {area} ({number_of_crops})
          </Typography>
          <IconButton
            disableRipple
            sx={{
              border: "none",
              backgroundColor: "transparent",
            }}
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon sx={{ float: "right", border: "none" }} />
            ) : (
              <ChevronRightIcon sx={{ float: "right", border: "none" }} />
            )}
          </IconButton>
        </Box>
        {open && (
          <Box p={1}>
            {crops.map((crop, idx) => (
              <Box
                key={idx}
                flexDirection="row"
                flex={1}
                display={"flex"}
                alignContent="center"
                alignItems="center"
                justifyContent="space-between"
                m={1}
                p={1}
                borderBottom={"1px solid #e0e0e0bf"}
                sx={{ cursor: "pointer" }}
                onClick={() => onClick && onClick(crop)}
              >
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {crop.name}
                </Typography>
                <StatusChip label={"Test"} status={"status1"} /> 
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  ); */
}
